@if (data$ | async; as data) {
  <footer kb-footer
    i18n-metaNavigationLabel="meta navigation label@@7876962745291386942" metaNavigationLabel="Meta navigation"
    [appEditorId]="data.editorId"
  >
    @for (link of data.attributes.links; track link) {
      <kb-footer-link
        [href]="link.attributes.url" [target]="link.attributes.target"
      >{{ link.attributes.label }}</kb-footer-link>
    }
    <kb-extended-footer>
      <nav kb-footer-link-section i18n-heading="footer quicklinks heading@@8761459569215107955" heading="Quicklinks">
        @for (link of data.attributes.quickLinks; track link) {
          <kb-footer-link
            [href]="link.attributes.url" [target]="link.attributes.target"
          >{{ link.attributes.label }}</kb-footer-link>
        }
      </nav>
      <address kb-footer-address [heading]="data.attributes.contactHeadline" [appEditorId]="data.editorIds?.contactHeadline">
        <kb-html [html]="data.attributes.contact" [appEditorId]="data.editorIds?.contact"></kb-html>
      </address>
      <nav kb-footer-icon-link-section i18n-heading="footer social media heading@@1340298141300120234" heading="Social Media">
        @for (link of data.attributes.socialMediaLinks; track link) {
          <kb-footer-icon-link
            [href]="link.attributes.url" target="_blank" [icon]="iconMap[link.attributes.icon]" [ariaLabel]="link.attributes.icon"
          ></kb-footer-icon-link>
        }
      </nav>
    </kb-extended-footer>
  </footer>
} @else {
  <footer class="loading">
    <kb-progress-indicator [visible]="true"></kb-progress-indicator>
  </footer>
}
